export default {"src":"/_next/static/media/Tooltip.425f788a.svg","height":21,"width":20};